import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      {/* <div className="logoheader flex justify-center mb-6">
        <img style={{ height: "70px" }} src="../images/dilips-logo.png" alt="logo" />
      </div> */}
      
      <h1 className="text-2xl font-bold mb-6 text-center">Privacy Policy</h1>
      
      <div className="content">
        <h2 className="text-lg font-semibold mb-3">Information We Collect</h2>
        <p className="mb-4">
          We collect information you provide directly to us, such as when you create an account, 
          participate in our loyalty program, or contact us for support.
        </p>

        <h2 className="text-lg font-semibold mb-3">How We Use Your Information</h2>
        <p className="mb-4">
          We use the information we collect to provide, maintain, and improve our loyalty program services, 
          process transactions, and communicate with you about your account and our services.
        </p>

        <h2 className="text-lg font-semibold mb-3">Information Sharing</h2>
        <p className="mb-4">
          We do not sell, trade, or otherwise transfer your personal information to third parties 
          without your consent, except as described in this privacy policy.
        </p>

        <h2 className="text-lg font-semibold mb-3">Data Security</h2>
        <p className="mb-4">
          We implement appropriate security measures to protect your personal information against 
          unauthorized access, alteration, disclosure, or destruction.
        </p>

        <h2 className="text-lg font-semibold mb-3">Contact Us</h2>
        <p className="mb-4">
          If you have any questions about this Privacy Policy, please contact us at our support channels.
        </p>
      </div>
      
      <div className="text-center mt-8">
        <button 
          onClick={() => window.history.back()} 
          className="redbtn"
        >
          Back
        </button>
      </div>
      
      <p className="flex justify-center mt-6">Dilipsindia Loyalty Programme</p>
    </div>
  );
};

export default PrivacyPolicy;